<div class="content">
    <div left-panel>
        <section-title [icon]="'person'" [text]="'Profile'"></section-title>
        <mat-card>
            <mat-card-content>
                <mat-form-field appearance="fill">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput [formControl]="nameFormControl" (input)="onChange()" placeholder="Name" [(ngModel)]="manager.name" name="name">
                    <mat-error *ngIf="nameFormControl.hasError('required')">Name is <strong>required</strong></mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput [formControl]="emailFormControl" (input)="onChange()" placeholder="Email" [(ngModel)]="manager.email" name="email">
                    <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">Please enter a valid email address</mat-error>
                    <mat-error *ngIf="emailFormControl.hasError('required')">Email is <strong>required</strong></mat-error>
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions>
                <button mat-stroked-button color="primary" [disabled]="!formValid() || !changed" (click)="save()">Save</button>
                <button mat-stroked-button (click)="cancel()">Cancel</button>
            </mat-card-actions>
        </mat-card>
    </div>
    <div right-panel>
        <div>
            <section-title [icon]="'security'" [text]="'Change Password'"></section-title>
            <mat-card>
                <mat-card-content>
                    <form>
                        <mat-form-field appearance="fill">
                            <mat-label>New password</mat-label>
                            <input [type]="showPassword ? 'text' : 'password'" matInput [formControl]="passwordFormControl" placeholder="New password" [(ngModel)]="resetPassword.password" name="password">
                            <mat-icon matSuffix class="button-cursor" [title]="showPassword ? 'Hide password' : 'Show password'" (click)="showPassword = !showPassword">{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                            <mat-error *ngIf="passwordFormControl.hasError('required')">Password is <strong>required</strong></mat-error>
                            <mat-error *ngIf="passwordFormControl.hasError('pattern')">Password is not enough <strong>strong</strong> (must be at least 8 characters length and contain one upper case letter, one lower case letter, one number and one special character)</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Confirm password</mat-label>
                            <input type="password" matInput [formControl]="confPasswordFormControl" placeholder="Confirm password" [(ngModel)]="confirmPassword" name="confirmPassword">
                            <mat-error *ngIf="confPasswordFormControl.hasError('required')">Password is <strong>required</strong></mat-error>
                            <mat-error *ngIf="confPasswordFormControl.hasError('notMatch')">Passwords must <strong>match</strong></mat-error>
                        </mat-form-field>
                    </form>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-stroked-button color="primary" [disabled]="!passwordFormValid()" (click)="saveChangePassword()">Change Password</button>
                    <button mat-stroked-button (click)="cancelChangePassword()">Cancel</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>